module.controller('productCategoryDetailCtrl', [ '$scope', '$rootScope', '$state', 'productCategoryService', 'alertService', 'parameterService', productCategoryDetailCtrlFn ]);
function productCategoryDetailCtrlFn($scope, $rootScope, $state, productCategoryService, alertService, parameterService) {

	$scope.operationType = $state.current.data.type;
	$scope.idProductCategory = $state.params.id;
	$scope.productCategory = {
		parent : {},
		requiredTakePhoto : false
	};
	$scope.loading = false;

	$scope.load = function(idProductCategory) {
		$scope.loading = true;

		productCategoryService.loadProductCategory(idProductCategory).then(function(response) {
			$scope.loading = false;

			var responseData = response.getData();
			$scope.productCategory = {
				name : responseData.name,
				requiredTakePhoto: responseData.requiredTakePhoto
			};

			if (responseData.parent) {
				$scope.productCategory.parent = {
					selected : [ responseData.parent ]
				};
			} else {
				$scope.productCategory.parent = {};
			}

		}, function(response) {
			$scope.loading = false;
		});
	};

	$scope.sendAction = function() {
		if ($scope.operationType == 'create') {
			$scope.create();
		} else {
			$scope.update();
		}
	};

	$scope.create = function() {
		alertService.showSwtQuestion('Crear categoría de producto', function() {
			$scope.loading = true;

			var createModel = {
				name : $scope.productCategory.name,
				requiredTakePhoto: $scope.productCategory.requiredTakePhoto
			};

			if ($scope.productCategory.parent.selected) {
				if ($scope.productCategory.parent.selected[0]) {
					createModel.idParent = $scope.productCategory.parent.selected[0].id;
				}
			}

			productCategoryService.createProductCategory(createModel).then(function(response) {
				$scope.loading = false;
				$state.go('home.productCategoryList');
				alertService.showSuccess('Categoría de producto creado satisfactoriamente');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	$scope.update = function() {
		alertService.showSwtQuestion('Actualizar categoría de producto', function() {
			$scope.loading = true;

			var updateModel = {
				name : $scope.productCategory.name,
				requiredTakePhoto: $scope.productCategory.requiredTakePhoto
			};

			if ($scope.productCategory.parent.selected) {
				if ($scope.productCategory.parent.selected[0]) {
					updateModel.idParent = $scope.productCategory.parent.selected[0].id;
				}
			}

			productCategoryService.updateProductCategory($scope.idProductCategory, updateModel).then(function(response) {
				$scope.loading = false;
				$state.go('home.productCategoryList');
				alertService.showSuccess('Categoría de producto satisfactoriamente');
			}, function(response) {
				$scope.loading = false;
			});
		});
	};

	if ($scope.operationType == 'update') {
		$scope.load($state.params.id);
	} else if ($scope.operationType == 'create') {
		if ($state.params.parentId) {
			$scope.productCategory.parent = {
				selected : [ {
					id : $state.params.parentId,
					name : $state.params.parentName
				} ]
			};
		}
	}

}
